/**
 * Tree type.
 * Specifies what table pattern will be used for the tree entity.
 */
export type TreeType = "adjacency-list"|"closure-table"|"nested-set"|"materialized-path";
